import {
  BookingLedgerRow,
  VariationLedgerRow,
  type LedgerCollapse,
  type LedgerColumn,
} from '../../../shared/components/ledger';
import { ActivityHoverCard } from './ActivityHoverCard';
import type { ActivityLedgerRowModel } from './toActivityRows';

interface ActivityLedgerRowProps {
  row: ActivityLedgerRowModel;
  columns: readonly LedgerColumn[];
  collapse: LedgerCollapse;
  onOpen: (row: ActivityLedgerRowModel) => void;
}

/**
 * One activity row. There is no context menu: admin cancel is a site and pot
 * affordance, and activity has never offered it.
 */
export function ActivityLedgerRow({
  row,
  columns,
  collapse,
  onOpen,
}: ActivityLedgerRowProps) {
  const shared = {
    columns,
    collapse,
    status: row.status,
    reference: row.reference,
    bookedBy: row.bookedBy,
    bookedAt: row.bookedAt,
    amount: row.amount,
    sitePlot: row.sitePlot,
    onClick: () => onOpen(row),
    hoverCard: (
      <ActivityHoverCard row={row} onOpenDetails={() => onOpen(row)} />
    ),
    'data-testid': `activity-row-${row.id}`,
  };

  if (row.isVariation) {
    return (
      <VariationLedgerRow
        {...shared}
        workTypeName={row.title}
        description={row.description ?? undefined}
      />
    );
  }

  return (
    <BookingLedgerRow
      {...shared}
      title={row.title}
      percentBooked={row.percentBooked}
    />
  );
}
